import React from "react"
import { Card, CardContent, Typography } from "@material-ui/core";

import CardHeader from "../UI/CardHeader";
import StudentDetailUpcomingCoursesItem from "./StudentDetailUpcomingCoursesItem";
import { UpcomingCourse } from "../../types/dashboard";
import { renderSkeleton } from "../FeedBack/Skeleton";

interface StudentDetailUpcomingCoursesProps {
    upcomingCourses?: UpcomingCourse[];
    loading: boolean;
}

const StudentDetailUpcomingCourses = ({ upcomingCourses, loading }: StudentDetailUpcomingCoursesProps) => {
    return (
        <div style={{ marginTop: "20px" }}>
            <Card elevation={2} >
                <CardHeader text="Ingeplande cursus(sen)" />
                {upcomingCourses && upcomingCourses.length === 0 ?
                    <CardContent>
                        <Typography variant="subtitle1" color="textPrimary">Er staan geen cursussen gepland voor deze medewerker</Typography>
                    </CardContent> :
                    <CardContent>
                        {loading && renderSkeleton(2, { xs: 12 }, 200, "rect")
                        }
                        {!loading && upcomingCourses && upcomingCourses.map((upcomingCourse, index) => {
                            return <StudentDetailUpcomingCoursesItem {...upcomingCourse} key={index} />
                        })}
                    </CardContent>
                }
            </Card>
        </div>
    );
};

export default StudentDetailUpcomingCourses;
